import { render } from "./MyChatAdsView.vue?vue&type=template&id=5421c657&scoped=true"
import script from "./MyChatAdsView.vue?vue&type=script&lang=js"
export * from "./MyChatAdsView.vue?vue&type=script&lang=js"

import "./MyChatAdsView.vue?vue&type=style&index=0&id=5421c657&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5421c657"]])

export default __exports__